import { NgIfContext, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { IUserData } from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-user-contact-details',
  templateUrl: './user-contact-details.component.html',
  styleUrls: ['./user-contact-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, TranslateModule],
})
export class UserContactDetailsWebComponent {
  @Input() userData: IUserData;
  @Input() noData: TemplateRef<NgIfContext<string>>;
}
